import { rankWith, scopeEndIs } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps, useJsonForms } from '@jsonforms/react';
import React from 'react';
import { Label, Description, Errors } from 'src/components/JsonForm/helpers';
import { JsonFormErrorFloatingPane } from 'src/components/JsonForm/JsonFormErrorFloatingPane';
import {
    defaultQuantityValue,
    defaultQuantityStepByInstrumentType,
    defaultQuantityStepMultiLeg,
} from 'src/components/JsonForm/ThinkalphaTheme';
import { StepperInput } from 'src/components/ui';
import type { OrderAction } from 'src/routes/widgets/TradeProWidget/state';

const QuantityControlComponent = ({
    id,
    data,
    path,
    description,
    errors,
    label,
    required,
    visible,
    handleChange,
}: ControlProps) => {
    const ctx = useJsonForms();
    const formData: { [key: string]: any } = ctx?.core?.data;
    const instrumentType = (formData?.instrument?.type as keyof typeof defaultQuantityStepByInstrumentType) ?? 'equity';
    const side = (formData?.side as OrderAction) ?? 'buy';
    const step =
        side === 'multi-leg' ? defaultQuantityStepMultiLeg : defaultQuantityStepByInstrumentType[instrumentType];

    const hasErrors = errors.length > 0;

    if (data === undefined) {
        handleChange(path, defaultQuantityValue);
    }

    return visible ? (
        <div>
            <div className="flex items-center gap-2">
                <Label label={label} required={required} htmlFor={id} />
                <Description description={description} />
            </div>
            <JsonFormErrorFloatingPane hasErrors={hasErrors} errors={<Errors errors={errors} />}>
                <StepperInput
                    id={id}
                    value={data}
                    onChange={(value: string) => {
                        const numValue = Number(value.replace(/_/g, ''));
                        const newValue = value !== '' && !isNaN(numValue) ? numValue : null;
                        handleChange(path, newValue);
                    }}
                    precision={0}
                    step={step}
                    dimensions="sm"
                    variant="light"
                />
            </JsonFormErrorFloatingPane>
        </div>
    ) : null;
};

export const QuantityControlTester = rankWith(
    10, //increase rank as needed
    scopeEndIs('quantity'),
);

export const QuantityControl = withJsonFormsControlProps(QuantityControlComponent);
